import React from 'react';
import PropTypes from 'prop-types';
/* Constants */
import {
  CAF_PREQUALIFY_ENTRY_POINT,
  CARZING_PREQUALIFY_ENTRY_POINT,
  FINANCING_CAF_CREATIVE_ID,
  FINANCING_CARZING_PREQUAL_CREATIVE_ID,
  FINANCING_CARZING_PREQUAL_TRIAL_CREATIVE_ID,
} from 'site-modules/shared/constants/financing/financing-constants';
/* Components */
import { Link } from 'site-modules/shared/components/link/link';
import { BenefitsWithIcons } from 'client/site-modules/shared/components/financing/components/benefits-with-icons/benefits-with-icons';
import { getCAFPrequalUrl } from 'site-modules/shared/utils/financing/caf-utils';

export function CAFPrequalifyEntryPoint({
  vinData,
  ted6504Recipe = 'ctrl',
  isProdEnv = false,
  isForceDefault = false,
  isCarZingPrequalify = false,
}) {
  const prequalifyEntryPoint = isCarZingPrequalify ? CARZING_PREQUALIFY_ENTRY_POINT : CAF_PREQUALIFY_ENTRY_POINT;
  const { benefits, ctaText: cta, header } = prequalifyEntryPoint;

  if (isCarZingPrequalify && !vinData?.listingUrl) {
    return null;
  }

  const linkUrl = isCarZingPrequalify
    ? `${vinData.listingUrl}&pop=y&ptn=y`
    : getCAFPrequalUrl({ vinData, isProdEnv, ted6504Recipe, isForceDefault });

  return (
    <>
      <hr
        style={{
          marginTop: '24px',
          marginBottom: '16px',
        }}
      />
      <div
        data-test="caf-prequal"
        style={{
          textAlign: 'left',
        }}
        data-tracking-parent={
          isCarZingPrequalify
            ? `${vinData?.dealerInfo?.partnerCode?.includes('TRIAL') ? FINANCING_CARZING_PREQUAL_TRIAL_CREATIVE_ID : FINANCING_CARZING_PREQUAL_CREATIVE_ID}`
            : FINANCING_CAF_CREATIVE_ID
        }
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'start',
          }}
        >
          <h2
            className="text-cool-gray-30"
            style={{
              fontWeight: 'bold',
              fontSize: '20px',
              marginBottom: '12px',
            }}
          >
            {header}
          </h2>

          <BenefitsWithIcons
            benefits={benefits}
            benefitsClass="d-flex justify-content-between w-100"
            benefitItemClass="d-flex flex-column align-items-start"
            benefitCopyClass="text-start size-14 fw-medium text-cool-gray-30"
          />

          <div
            style={{
              display: 'flex',
              justifyContent: 'left',
            }}
          >
            <Link
              to={linkUrl}
              target="_blank"
              className="btn btn-md btn-success"
              style={{
                marginTop: '12px',
                textTransform: 'none',
                fontSize: '16px',
                fontWeight: 'normal',
              }}
              data-tracking-id="financing_cta"
              data-tracking-value={cta}
            >
              <span>
                {cta}
                <i className="icon-open_in_new medium ms-0_25" aria-hidden />
              </span>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

CAFPrequalifyEntryPoint.propTypes = {
  vinData: PropTypes.shape({
    listingUrl: PropTypes.string,
  }).isRequired,
  ted6504Recipe: PropTypes.string,
  isProdEnv: PropTypes.bool,
  isForceDefault: PropTypes.bool,
  isCarZingPrequalify: PropTypes.bool,
};
